import { createFileRoute, redirect } from "@tanstack/react-router";

import { GeneralSettings } from "../components/settings/GeneralSettings";
import { settingsGeneralHashRedirect } from "./settingsDiagnosticsRedirects";

export const Route = createFileRoute("/settings/general")({
  beforeLoad: ({ location }) => {
    const next = settingsGeneralHashRedirect(location.hash);
    if (next) throw redirect(next);
  },
  component: GeneralSettings,
});
